import React from 'react';
import classNames from 'classnames';

import Card from '@components/libraryV2/Card';
import ContentWell from '@components/libraryV2/ContentWell';
import Heading from '@components/libraryV2/Heading';
import Text from '@components/libraryV2/Text';
import TextBubble from '@components/libraryV2/TextBubble';
import ThemeText from '@components/libraryV2/ThemeText';

import AwardDocumentsSvg from '@svg/generic/award-documents.svg';
import ClockBriefcasesSvg from '@svg/generic/clock-briefcases.svg';
import PersonalizedLearningSvg from '@svg/generic/personalized-learning.svg';

import * as styles from './styles.module.scss';

const Benefit = (props) => {
  const { children, icon, position, reverse, title } = props;

  return (
    <>
      <div className={classNames(styles.benefit, reverse && styles.reverse)}>
        <div className={styles.circle} />
        <div className={styles.icon}>{icon}</div>
        <div className={styles.content}>
          <div className={styles.title}>
            <TextBubble className={styles.bubble} size="mouse">
              {position}
            </TextBubble>{' '}
            {title}
          </div>
          <div className={styles.descriptionContainer}>
            <Text className={styles.description} theme="secondary">
              {children}
            </Text>
          </div>
        </div>
      </div>

      <Card className={styles.benefitMobile}>
        {icon}
        <div className={styles.title}>{title}</div>
        <Text theme="secondary">{children}</Text>
      </Card>
    </>
  );
};

const Benefits = () => {
  return (
    <ContentWell
      className={styles.layout}
      backgroundSize="medium"
      secondary
      tighten
      hideBackgroundMobile
      reverseBackground
      withBackground
    >
      <Heading className={styles.heading} size="h2" tagType="h2">
        The <ThemeText>best way</ThemeText> to prepare
      </Heading>
      <div className={styles.benefits}>
        <Benefit icon={<AwardDocumentsSvg />} position={1} title="Complete content">
          Ditch the textbook. Achievable is a complete learning solution backed by
          award-winning content experts.
        </Benefit>
        <Benefit
          icon={<PersonalizedLearningSvg />}
          position={2}
          title="Personalized learning"
          reverse
        >
          Our algorithms adapt to your strengths and weaknesses, creating an individual
          review schedule for optimal results.
        </Benefit>
        <Benefit icon={<ClockBriefcasesSvg />} position={3} title="Flexible studying">
          Bite-sized content means you can study anytime, anywhere, from a quick break at work to a
          quiet moment on your commute.
        </Benefit>
      </div>
    </ContentWell>
  );
};

export default Benefits;
